var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00583 0.253906C4.48603 0.25563 3.02898 0.860132 1.95432 1.93479C0.879662 3.00945 0.275162 4.46651 0.273438 5.98631C0.273438 10.8914 5.4847 14.5979 5.70618 14.7543C5.79494 14.8134 5.89919 14.8449 6.00583 14.8449C6.11246 14.8449 6.21672 14.8134 6.30548 14.7543C6.52695 14.5979 11.7382 10.8914 11.7382 5.98631C11.7365 4.46651 11.132 3.00945 10.0573 1.93479C8.98268 0.860132 7.52562 0.25563 6.00583 0.253906ZM6.00583 3.9018C6.4181 3.9018 6.82112 4.02405 7.16392 4.2531C7.50671 4.48215 7.77389 4.8077 7.93166 5.1886C8.08943 5.56949 8.13071 5.98862 8.05028 6.39297C7.96985 6.79733 7.77132 7.16875 7.4798 7.46028C7.18827 7.7518 6.81685 7.95033 6.4125 8.03076C6.00814 8.11119 5.58902 8.06991 5.20812 7.91214C4.82723 7.75437 4.50167 7.48719 4.27262 7.1444C4.04358 6.8016 3.92132 6.39858 3.92132 5.98631C3.92132 5.43346 4.14094 4.90326 4.53186 4.51234C4.92278 4.12141 5.45298 3.9018 6.00583 3.9018Z",
    fill: "#252538"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.129a42c48991a295e70419aaa3546ea3.svg";
export { ForwardRef as ReactComponent };